import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Connects to data-controller="sortable"
export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: ".grippy",
      onEnd: this.updateOrder.bind(this)
    });
  }

  updateOrder(event) {
    // Get the new order of IDs from data-id attributes
    const sortedIds = Array.from(this.element.children).map(row => row.dataset.id);
    
    // Detect the model type from the first row's DOM ID
    const firstRow = this.element.children[0];
    if (!firstRow) return;
    
    // dom_id generates IDs like "products_index_page_1" or "products_table_note_5"
    const domId = firstRow.id;
    const modelName = this.extractModelName(domId);
    
    // Get CSRF token
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    
    // Log what we're sending for debugging
    console.log('Sending sorted IDs:', sortedIds, 'for model:', modelName);
    
    // Send the new order to the server
    fetch('/admin/sortable/reorder', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        sorted_ids: sortedIds,
        model: modelName
      })
    })
    .then(response => {
      console.log('Response status:', response.status);
      if (!response.ok) {
        console.error('Failed to update order');
        return response.text().then(text => {
          console.error('Response body:', text);
        });
      } else {
        console.log('Order updated successfully');
      }
    })
    .catch(error => {
      console.error('Error updating order:', error);
    });
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }
  
  extractModelName(domId) {
    // Convert dom_id format to model class name
    // "products_index_page_1" -> "ProductsIndexPage"
    // "products_table_note_5" -> "ProductsTableNote"
    
    // Remove the trailing ID number
    const parts = domId.split('_');
    const idPart = parts.pop(); // Remove the ID
    
    // Convert to CamelCase
    const modelName = parts.map(part => 
      part.charAt(0).toUpperCase() + part.slice(1)
    ).join('');
    
    // Special case for join tables that Rails generates differently
    if (modelName === 'ProductsTablesProductNote') {
      return 'ProductNotesProductsTable';
    }
    
    return modelName;
  }
}